import React from 'react';
import { useSelector } from 'react-redux';
import { getLoginData } from '../../Public/login-data.js';

function fmt(secs) {
    if (!secs || secs <= 0) return '0:00';
    const m = Math.floor(secs / 60);
    const s = secs % 60;
    return `${m}:${String(s).padStart(2, '0')}`;
}

export default function SessionExpiryBadge({ secsLeft, hidden }) {
    const { language = 'en' } = useSelector((s) => s.systemData || {});
    const txt = getLoginData(language);
    const urgent = secsLeft !== null && secsLeft <= 10 * 60;

    if (!secsLeft || hidden) return null;

    return (
        <div
            className={`fixed bottom-4 right-4 z-50 flex items-center gap-2 px-3 py-2 rounded-full shadow-lg text-sm font-primary font-semibold transition-colors ${
                urgent ? 'bg-secondary-500 text-white' : 'bg-primary-500 text-white'
            }`}
        >
            <svg className="w-4 h-4 flex-shrink-0" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth="1.5" stroke="currentColor">
                <path strokeLinecap="round" strokeLinejoin="round" d="M12 6v6h4.5m4.5 0a9 9 0 11-18 0 9 9 0 0118 0z" />
            </svg>
            <span>{txt.sessionBadgeLabel} {fmt(secsLeft)}</span>
        </div>
    );
}
